module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 1
      }),
      expression: "{ zIndex: 1 }"
    }],
    staticClass: "wrapper"
  }, [_c('div', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb4f6560"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sticky.vue
// module id = 139
// module chunks = 0